// ─── Landing token shim → src/theme/tokens.js ────────────────────────────────
//
// These tokens are no longer landing-scoped: they were promoted to the global
// module at `src/theme/tokens.js`, which is now the single source of design
// values for the whole frontend (STACK-487, design doc D-1).
//
// This file survives only so the ~22 files importing `LC` / `MOTION` / friends
// did not have to churn in the promotion PR. **Import from `src/theme/tokens`
// in new code.** The landing surface migrates off this shim in a later phase.
//
// One rename to know about: the brief calls `#9FD9BE` "Soft Accent" and
// reserves the name "Mint" for `#E4EFE8` (a surface, added in v1.1 D8). The
// global module follows the brief; `LC.mint` below keeps pointing at the value
// it always did, so nothing on the landing moves.
// ─────────────────────────────────────────────────────────────────────────────

import { color, reveal } from '../../theme/tokens';

export {
  r,
  BP,
  MAXW,
  PAD_X,
  SECTION_Y,
  containerSx,
  easeOut,
} from '../../theme/tokens';

export { FONT_FAMILY as LANDING_FONT } from '../../theme/tokens';

// Scroll-reveal choreography. Renamed to `reveal` globally, because `motion` in
// `src/theme/tokens.js` is now the brief's product-wide motion scale
// (150/250/300ms, 1.6s loop) — a different thing.
export const MOTION = reveal;

// Landing colour names → global tokens. Left-hand names are frozen: they are
// what the landing files already import. Where the brief renamed a value, the
// mapping happens here and nowhere else.
export const LC = {
  evergreen:     color.evergreen,
  accent:        color.accent,
  accentInk:     color.accentInk,
  accentHover:   color.accentHover,
  linkHover:     color.linkHover,
  mint:          color.softAccent,   // brief: Soft Accent (#9FD9BE)
  heroMid:       color.heroMid,
  heroDark:      color.heroDark,

  strengthBar:   color.strengthFill, // brief: study-strength fill
  ringTrack:     color.ringTrack,

  ink:           color.ink,
  inkSoft:       color.inkSoft,
  inkMuted:      color.inkMuted,

  surface:       color.paper,        // brief: Paper (#FBFCFB)
  surfaceAlt:    color.surface,      // brief: Surface (#F4F7F5)
  surfaceTint:   color.mintSoft,     // brief: the #EDF4EF mint pair
  border:        color.line,         // brief: Hairline (#DDE5E0)
  borderSoft:    color.borderSoft,

  posBg:         color.posBg,
  posInk:        color.posInk,
  posBorder:     color.posBorder,

  cautionBg:     color.cautionBg,
  cautionBorder: color.cautionBorder,
  cautionDot:    color.riskMedium,   // brief: Risk · Medium (#DC8209)
  cautionInk:    color.cautionInk,

  navLink:       color.navLink,
  heroLead:      color.heroLead,
};
